import type { OrderLocation } from "./InfoPopup";

export interface PolygonSelectionSummary {
  orderCount: number;
  totalValue: number;
  customerCount: number | null;
  addressCount: number | null;
}

// Use saved identities rather than names, phone numbers or rounded GPS locations.
export function summarizePolygonOrders(orders: OrderLocation[]): PolygonSelectionSummary {
  const unique = Array.from(new Map(orders.map(o => [o.orderId, o])).values());
  const distinct = (key: "customerId" | "addressId") => {
    const ids = unique.map(o => o[key]);
    return ids.every(id => typeof id === "number" && Number.isSafeInteger(id) && id > 0)
      ? new Set(ids).size : null;
  };
  return {
    orderCount: unique.length,
    totalValue: unique.reduce((sum, o) => {
      const value = Number(o.taxableAmount ?? o.amount);
      return sum + (Number.isFinite(value) ? Math.round(value * 100) : 0);
    }, 0) / 100,
    customerCount: distinct("customerId"),
    addressCount: distinct("addressId"),
  };
}
